import ModelUpdate from "@/models/ModelUpdate";
import Company from "@/models/company/Company";
import {ValidationRule} from "@/declarations/ValidationRule";
import CompanyRules from "@/models/company/CompanyRules";
import {CompanyType} from "@/helpers/constants";

export default class CompanyUpdate extends ModelUpdate<Company> {

	public type!: CompanyType;
	public name!: string;

	public hourlyRate!: number | null;
	public dailyLumpSum!: number | null;
	public notes!: string | null;

	protected initializeWithDetailModelData(detailModel: Company): void {
		this.type = detailModel.type;
		this.name = detailModel.name;
		this.hourlyRate = detailModel.hourlyRate;
		this.dailyLumpSum = detailModel.dailyLumpSum;
		this.notes = detailModel.notes;
	}

	public rules(property: string): ValidationRule[] {
		switch (property) {
			case 'type':
				return CompanyRules.typeRules;
			case 'name':
				return CompanyRules.nameRules;
			case 'hourlyRate':
				return CompanyRules.hourlyRateRules;
			case 'dailyLumpSum':
				return CompanyRules.dailyLumpSum;
			default:
				return [];
		}
	}

}
